module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-blue-77145c25954ad9c7c7e79f2a0d5194be.svg";